
    export default {
        props: {
            region: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
            cards: {
                type: String,
                default: 'cardsDefault',
            },
            cta: {
                type: String,
                default: 'Get the guide!',
            }
        },
        data(){
            return {
                cardsArray:{
                    cardsDefault:[
                        {
                            class:"third px-4",
                            src:"https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-certified-diploma-b@48x48.svg",
                            text:"<p><strong>What requirements you'll need</strong> to live and work all over the world.</p>",
                            alt:"Requirements icon",
                            id: 1
                        },
                        {
                            class:"third px-4",
                            src: "https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-job-search-g@48x48.svg",
                            text: "<p><strong>How to find jobs</strong> and start your teaching career.</p>",
                            alt: "How to find jobs icon",
                            id: 2
                        },
                        {
                            class:"third last px-4",
                            src: "https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-cash-payment-coins@48x48.svg",
                            text: "<p><strong>How much you can expect to earn</strong> and the cost of living.</p>",
                            alt: "How much you can earn icon",
                            id: 3
                        }
                    ],
                    cardsOnline:[
                        {
                            class:"third px-4",
                            src:"https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-certified-diploma-b@48x48.svg",
                            text:"<p><strong>What requirements you'll need</strong> to live and work online.</p>",
                            alt:"Requirements icon",
                            id: 1
                        },
                        {
                            class:"third px-4",
                            src: "https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-job-search-g@48x48.svg",
                            text: "<p><strong>How to find jobs</strong> and start your teaching career.</p>",
                            alt: "How to find jobs icon",
                            id: 2
                        },
                        {
                            class:"third last px-4",
                            src: "https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-cash-payment-coins@48x48.svg",
                            text: "<p><strong>How much you can expect to earn</strong> and the cost of living.</p>",
                            alt: "How much you can earn icon",
                            id: 3
                        }
                    ],
                    cardsWorld:[
                        {
                            class:"third px-4",
                            src:"https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-certified-diploma-b@48x48.svg",
                            text:"<p><strong>What requirements you'll need</strong> to live and work all over the world.</p>",
                            alt:"Requirements icon",
                            id: 1
                        },
                        {
                            class:"third px-4",
                            src: "https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-job-search-g@48x48.svg",
                            text: "<p><strong>How to find jobs</strong> and start your teaching career.</p>",
                            alt: "How to find jobs icon",
                            id: 2
                        },
                        {
                            class:"third last px-4",
                            src: "https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-cash-payment-coins@48x48.svg",
                            text: "<p><strong>How much you can expect to earn</strong> and the cost of living.</p>",
                            alt: "How much you can earn icon",
                            id: 3
                        }
                    ],
                    cardsTaster:[
                        {
                            class:"third px-4",
                            src:"https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-certified-diploma-b@48x48.svg",
                            text:"<p><strong>Learn why you DON'T need a degree or experience to teach EFL</strong> - just passion and the right training!</p>",
                            alt:"Requirements icon",
                            id: 1
                        },
                        {
                            class:"third px-4",
                            src: "https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-job-search-g@48x48.svg",
                            text: "<p><strong>Discover how our accredited TEFL Org courses prepare you for a world of opportunities,</strong> even if you're not a native English speaker.</p>",
                            alt: "How to find jobs icon",
                            id: 2
                        },
                        {
                            class:"third last px-4",
                            src: "https://cdn-wp.tefl.org/wp-content/themes/tefl/icons/streamline-icon-e-learning-laptop-g@48x48.svg",
                            text: "<p><strong>Get an intro to grammar</strong> - the backbone of teaching English - and test your knowledge with our fun quiz.</p>",
                            alt: "How much you can earn icon",
                            id: 3
                        }
                    ],
                    cardsNewsletter:[
                        {
                            class:"third px-4",
                            src:"https://cdn-wp.tefl.org/wp-content/uploads/2022/07/streamline-icon-tag-new@48x48.svg",
                            text:"<p><strong>Breaking TEFL news</strong><br>Be the first to know about the latest updates and developments in the industry, from policy changes to exciting new teaching opportunities.</p>",
                            alt:"Requirements icon",
                            id: 1
                        },
                        {
                            class:"third px-4",
                            src: "https://cdn-wp.tefl.org/wp-content/uploads/2022/07/streamline-icon-conversation-question-warning@48x48.svg",
                            text: "<p><strong>Emerging trends and innovations</strong><br>Stay ahead of the game with insights into the latest teaching methods, technologies, and best practices.</p>",
                            alt: "How to find jobs icon",
                            id: 2
                        },
                        {
                            class:"third last px-4",
                            src: "https://cdn-wp.tefl.org/wp-content/uploads/2022/07/streamline-icon-earth-locate@48x48.svg",
                            text: "<p><strong>Global TEFL community updates</strong><br>Connect with the worldwide TEFL community and learn about inspiring stories, events, and collaborative opportunities.</p>",
                            alt: "How much you can earn icon",
                            id: 3
                        }
                    ]
                }
            }
        }
    }
